import type { Stage } from '@shared/model';
import { STAGES, STAGE_COLOR, STAGE_HINT, STAGE_LABEL } from '@shared/model';

/**
 * The onboarding funnel: how many holders have reached each stage. Bars are
 * proportional to the first (everyone on the record), so an empty programme
 * reads as one long grey bar and nothing else, which is the truth.
 */
export function Funnel({ reached, compact }: { reached: Record<Stage, number>; compact?: boolean }): JSX.Element {
  const base = Math.max(1, reached.target);
  return (
    <ol className={`funnel ${compact ? 'funnel--compact' : ''}`}>
      {STAGES.map((s, i) => {
        const n = reached[s];
        const prev = i === 0 ? n : reached[STAGES[i - 1]!];
        const drop = i === 0 || prev === 0 ? null : Math.round((n / prev) * 100);
        return (
          <li key={s} title={STAGE_HINT[s]}>
            <span className="funnel__label">{STAGE_LABEL[s]}</span>
            <span className="funnel__bar">
              <i style={{ width: `${Math.max(0.6, (n / base) * 100)}%`, background: STAGE_COLOR[s] }} />
            </span>
            <span className="funnel__n">{n.toLocaleString('en-IN')}</span>
            {!compact ? <span className="funnel__pct">{drop === null ? '' : `${drop}% of previous`}</span> : null}
          </li>
        );
      })}
    </ol>
  );
}
